import api from './api';

export const bulkContractService = {
    // Bulk Contract Entry Operations
    async createBulkContracts(bulkData) {
        const response = await api.post('/BulkContracts', bulkData);
        return response.data;
    },

    async getAllBulkEntries() {
        const response = await api.get('/BulkContracts');
        return response.data;
    },

    async getBulkEntryById(id) {
        const response = await api.get(`/BulkContracts/${id}`);
        return response.data;
    },

    async deleteBulkEntry(id) {
        await api.delete(`/BulkContracts/${id}`);
    },

    // Bulk Additional Acts
    async createBulkAdditionalActs(bulkEntryId, data) {
        const response = await api.post(`/BulkContracts/${bulkEntryId}/additional-acts`, data);
        return response.data;
    },

    async getBulkAdditionalActs(bulkEntryId) {
        const response = await api.get(`/BulkContracts/${bulkEntryId}/additional-acts`);
        return response.data;
    },

    async downloadBulkAdditionalActs(bulkAdditionalActId) {
        const response = await api.get(`/BulkContracts/additional-acts/${bulkAdditionalActId}/download`, {
            responseType: 'blob',
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = `ActeAditionale_Bulk_${bulkAdditionalActId}.zip`;

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']+)['"]?(?:$|;)/i);
            if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
            }
        }

        return { blob: response.data, filename };
    },

    // ACTUALIZAT: Trimite email-uri pentru acte adiționale cu rezultate detaliate
    async sendBulkAdditionalActEmails(bulkAdditionalActId, additionalEmails = null) {
        const response = await api.post(
            `/BulkContracts/additional-acts/${bulkAdditionalActId}/send`, 
            { additionalEmails }
        );
        return response.data; // Returnează BulkEmailResultDto
    },

    // Bulk Notices
    async createBulkNotices(bulkEntryId, data) {
        const response = await api.post(`/BulkContracts/${bulkEntryId}/notices`, data);
        return response.data;
    },

    async getBulkNotices(bulkEntryId) {
        const response = await api.get(`/BulkContracts/${bulkEntryId}/notices`);
        return response.data;
    },

    async downloadBulkNotices(bulkNoticeId) {
        const response = await api.get(`/BulkContracts/notices/${bulkNoticeId}/download`, {
            responseType: 'blob',
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = `Notificari_Bulk_${bulkNoticeId}.zip`;

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']+)['"]?(?:$|;)/i);
            if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
            }
        }

        return { blob: response.data, filename };
    },

    // ACTUALIZAT: Trimite email-uri pentru notificări cu rezultate detaliate
    async sendBulkNoticeEmails(bulkNoticeId, additionalEmails = null) {
        const response = await api.post(
            `/BulkContracts/notices/${bulkNoticeId}/send`, 
            { additionalEmails }
        );
        return response.data; // Returnează BulkEmailResultDto
    },

    // Bulk Download & Send
    async downloadBulkContracts(bulkEntryId) {
        const response = await api.get(`/BulkContracts/${bulkEntryId}/download`, {
            responseType: 'blob',
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = `Contracte_Bulk_${bulkEntryId}.zip`;

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']+)['"]?(?:$|;)/i);
            if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
            }
        }

        return { blob: response.data, filename };
    },

    // ACTUALIZAT: Trimite email-uri pentru contracte cu rezultate detaliate
    async sendBulkContractEmails(bulkEntryId, additionalEmails = null) {
        console.log("sendBulkContractEmails called with bulkEntryId:", bulkEntryId);
        const response = await api.post(
            `/BulkContracts/${bulkEntryId}/send`, 
            { additionalEmails }
        );
        return response.data; // Returnează BulkEmailResultDto
    },

    // Client Warnings
    async checkClientWarnings(clientId) {
        const response = await api.get(`/BulkContracts/client-warnings/${clientId}`);
        return response.data;
    },

    async checkMultipleClientWarnings(clientIds) {
        const response = await api.post('/BulkContracts/client-warnings/batch', clientIds);
        return response.data;
    },

    // Statistics
    async getBulkStatistics() {
        const response = await api.get('/BulkContracts/statistics');
        return response.data;
    },

    // PDF Generation
    async generateBulkPdfs(bulkEntryId) {
        const response = await api.post(`/BulkContracts/${bulkEntryId}/generate-pdfs`);
        return response.data;
    },

    async generateBulkAdditionalActPdfs(bulkAdditionalActId) {
        const response = await api.post(`/BulkContracts/additional-acts/${bulkAdditionalActId}/generate-pdfs`);
        return response.data;
    },

    async generateBulkNoticePdfs(bulkNoticeId) {
        const response = await api.post(`/BulkContracts/notices/${bulkNoticeId}/generate-pdfs`);
        return response.data;
    }
};